// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ButtonPresentationPropsDefault from "@insite/mobius/Button/presentationProps";
import { xBaseTheme } from "@tps/XDL/types";
import { getSystemColor } from "@tps/XDL/Utilities/color";
import { css } from "styled-components";

export const buttonTransparent = css`
    &,
    &:focus:not([disabled]),
    &:active:not([disabled]),
    &:disabled,
    &:focus:hover,
    &:hover:not(:disabled) {
        border: none;
        background-color: transparent;
        box-shadow: none;
        outline: 0;
        transform: translate(0, 0);
        min-height: initial;
    }
`;

export const buttonColors: { [key: string]: { main: string; hover: string; text: string; focus: string } } = {
    primary: {
        main: "primary",
        hover: "common.ui8",
        text: "common.ui1",
        focus: "common.ui9",
    },
    secondary: {
        main: "primary",
        hover: "common.ui8",
        text: "primary",
        focus: "common.ui9",
    },
    tertiary: {
        main: "primary",
        hover: "common.ui8",
        text: "primary",
        focus: "common.ui9",
    },
};
const sharedButtonStyle = {
    ...ButtonPresentationPropsDefault,
    color: buttonColors.secondary.main,
    buttonType: "outline",
    mergeCss: true,
    hoverStyle: {
        borderColor: `${getSystemColor(buttonColors.secondary.hover)}`,
        color: `${getSystemColor(buttonColors.secondary.hover)}`,
    },
    css: css`
        border: 1px solid;
        border-radius: 2px;
        &:focus,
        &:not(:disabled):focus {
            border-color: ${getSystemColor(buttonColors.secondary.focus)};
            color: ${getSystemColor(buttonColors.secondary.focus)};
        }
        &:disabled {
            border-color: ${getSystemColor(buttonColors.secondary.main, 0.33)};
            color: ${getSystemColor(buttonColors.secondary.main, 0.33)};
        }
    `,
};
export default {
    primary: {
        ...ButtonPresentationPropsDefault,
        color: buttonColors.primary.main,
        buttonType: "solid",
        mergeCss: true,
        hoverStyle: {
            background: `${getSystemColor(buttonColors.primary.hover)}`,
            borderColor: `${getSystemColor(buttonColors.primary.hover)}`,
            color: `${getSystemColor(buttonColors.primary.hover)}`,
        },
        css: css`
            border-radius: 2px;
            &:focus {
                background: ${getSystemColor(buttonColors.primary.focus)};
                border-color: ${getSystemColor(buttonColors.primary.focus)};
            }
            &:disabled {
                background: ${getSystemColor(buttonColors.primary.main, 0.33)};
                border-color: transparent;
            }
        `,
    },
    secondary: {
        ...sharedButtonStyle,
    },
    tertiary: {
        ...sharedButtonStyle,
    },
} as xBaseTheme["button"];
